import { HGroup } from "../area/HGroup";
import { Sol50 } from "../mountsys/Sol50";

export default class SnapPanel {
    // static groups: any = [];
    //setting snap value to 20% of panel width for both portrait and landscape
    static nSnapVal: number = 20;
    static panelWidthPer = 20;

    static snapCal(group: any[], panel: any) {

        var nModRightDifY: number = 999;
        var nModRightDifX: number = 999;
        var gLeft: any = null;
        var nModLeftDifY: number = 999;
        var nModLeftDifX: number = 999;
        var gTop: any = null;
        var nModTopDifY: number = 999;
        var nModTopDifX: number = 999;
        var gBottom: any = null;
        var nModBottomDifY: number = 999;
        var nModBottomDifX: number = 999;
        const nHSpace = Sol50.nHorizontalAbstand;
        const nVSpace = Sol50.nVertikalAbstand;

        // var nDifY:number;
        var g: any = null;
        var gX: any = null;
        var gY: any = null;

        g = new HGroup(group);
        // groups.push(g);
        var nDifX: number = 0;
        var nDifY: number = 0;
        var nDifX2: number = 999;
        var nDifY2: number = 999;
        // let nDifX = 0;
        var nX: number = 0;
        var nY: number = 0;
        var gLeft = null;
        var gRight = null;
        var gTop = null;
        var gBottom = null;
        var nDifY2: number = 999;

        //console.log('panel.width',panel.width);
        //console.log('snapvalue',panel.width * (SnapPanel.panelWidthPer /100));
        //setting snap value to 20% of panel width // not working for landscape mode
       // SnapPanel.nSnapVal = panel.width * (SnapPanel.panelWidthPer /100);


        //Left
        nDifX = Math.abs((g.x + g.width) - panel.x);
        

        //console.log('nDifX calc ',g.x,g.width,panel.x , nDifX);
        if (panel.y < g.y) {
            nDifY = g.y - panel.y;
        }
        //console.log('nDifY1 calc ',g.y,panel.y,nDifY);
        //console.log('nDifY2 calc cond',panel.y + panel.height,g.y + g.height);
        //no need for considering height here //panel.y > g.y both cond same
        if (panel.y + panel.height > g.y + g.height) {
            
            //console.log('nDifY2 calc res',nDifY,(panel.y + panel.height) - (g.y + g.height));
            nDifY += (panel.y + panel.height) - (g.y + g.height);
            //console.log('nDifY2 calc res',nDifY,);
        }
        
        //console.log('left',nDifX,SnapPanel.nSnapVal,nDifY,panel.height);
        if (nDifX < SnapPanel.nSnapVal && nDifY < panel.height) {
            if (nModLeftDifX > nDifX) {
                gLeft = g;//selecting the group to attach the panel
                nModLeftDifY = nDifY;
                nModLeftDifX = nDifX;
            } else if (nModLeftDifX == nDifX && nModLeftDifY > nDifY) {
                gLeft = g;
                nModLeftDifY = nDifY;
                nModLeftDifX = nDifX;
            }

        }
        //Right
        nDifY = 0;
        nDifX = 0;
        nDifX = Math.abs(g.x - (panel.x + panel.width));
        //console.log('nDifX calc ',g.x,g.width,panel.x , nDifX);
        if (panel.y < g.y) {
            nDifY = g.y - panel.y;
        }
        if (panel.y + panel.height > g.y + g.height) {
            nDifY += (panel.y + panel.height) - (g.y + g.height);
        }
        if (nDifX < SnapPanel.nSnapVal && nDifY < panel.height) {
            if (nModRightDifX > nDifX) {
                gRight = g;
                nModRightDifY = nDifY;
                nModRightDifX = nDifX;
            } else if (nModRightDifX == nDifX && nModRightDifY > nDifY) {
                gRight = g;
                nModRightDifY = nDifY;
                nModRightDifX = nDifX;
            }
        }


        //Top
        nDifY = 0;
        nDifX = 0;
        nDifY = Math.abs((g.y + g.height) - panel.y);
        if (panel.x < g.x) {
            nDifX = g.x - panel.x;
        }
        if (panel.x + panel.width > g.x + g.width) {
            nDifX += (panel.x + panel.width) - (g.x + g.width);
        }
        if (nDifY < SnapPanel.nSnapVal && nDifX < panel.width) {
            if (nModTopDifY > nDifY) {
                gTop = g;
                nModTopDifX = nDifX;
                nModTopDifY = nDifY;
            } else if (nModTopDifY == nDifY && nModTopDifX > nDifX) {
                gTop = g;
                nModTopDifX = nDifX;
                nModTopDifY = nDifY;
            }
        }
        //Bottom
        nDifY = 0;
        nDifX = 0;
        nDifY = Math.abs(g.y - (panel.y + panel.height));
        if (panel.x < g.x) {
            nDifX = g.x - panel.x;
        }
        if (panel.x + panel.width > g.x + g.width) {
            nDifX += (panel.x + panel.width) - (g.x + g.width);
        }
        if (nDifY < SnapPanel.nSnapVal && nDifX < panel.width) {
            if (nModBottomDifY > nDifY) {
                gBottom = g;
                nModBottomDifX = nDifX;
                nModBottomDifY = nDifY;
            } else if (nModBottomDifY == nDifY && nModBottomDifX > nDifX) {
                gBottom = g;
                nModBottomDifX = nDifX;
                nModBottomDifY = nDifY;
            }
        }

        //console.log('gleft',gLeft);
        //console.log('gright',gRight);
        //console.log('gtop',gTop);
        //console.log('gbottom4',gBottom);
        if (gRight !== null) {
            if (gLeft !== null) {
                if (nModRightDifX > nModLeftDifX) {
                    nX = gLeft.x + nHSpace + gLeft.width;
                    nDifX = nModLeftDifX;
                    nDifY2 = nModLeftDifY;
                    gX = gLeft;
                } else {
                    nX = gRight.x - (nHSpace + panel.width);
                    nDifX = nModRightDifX;
                    nDifY2 = nModRightDifY;
                    gX = gRight;
                }
            } else {
                nX = gRight.x - (nHSpace + panel.width);
                nDifX = nModRightDifX;
                nDifY2 = nModRightDifY;
                gX = gRight;
            }
        } else {
            if (gLeft !== null) {
                nX = gLeft.x + nHSpace + gLeft.width;//new starting point after grouping the panel
                nDifX = nModLeftDifX;
                nDifY2 = nModLeftDifY;
                gX = gLeft;
            }
        }
        if (gTop !== null) {
            if (gBottom !== null) {
                if (nModTopDifY > nModBottomDifY) {
                    nY = gBottom.y - (nVSpace + panel.height);
                    nDifY = nModBottomDifY;
                    nDifX2 = nModBottomDifX;
                    gY = gBottom;
                } else {
                    nY = gTop.y + nVSpace + gTop.height;
                    nDifY = nModTopDifY;
                    nDifX2 = nModTopDifY;
                    gY = gTop;
                }
            } else {
                nY = gTop.y + nVSpace + gTop.height;
                nDifY = nModTopDifY;
                nDifX2 = nModTopDifX;
                gY = gTop;
            }
        } else {
            if (gBottom !== null) {
                nY = gBottom.y - (nVSpace + panel.height);
                nDifY = nModBottomDifY;
                nDifX2 = nModBottomDifX;
                gY = gBottom;
            }
        }
        //left/right condition - exact match fit 
        if (nDifY2 < this.nSnapVal && gX !== null && panel.height == gX.height) {
            gY = gX;
            nY = gX.y;
            //console.log('left/right condition - exact match fit ');
            // && nDifY < nDifX
        }//top/bottom condition - exact match fit 
        else if (nDifX2 < this.nSnapVal && gY !== null && panel.width == gY.width) {
            gX = gY;
            nX = gY.x;
            //console.log('top/bottom condition - exact match fit ');
        }
        // if(gX === null) {
        //     nX = panel.x;
        // }
        // if(gY === null) {
        //     nY = panel.y;
        // }
        if (gX || gY) {
            //console.log('  match found  condition');
            if (gX) {
                //setting values for exact match left/right
                nX = gX.x;
                nY = gX.y;
                g = gX;
                // console.log("gx")
            }

            if (gY) {
                //setting values for exact match top/bottom
                nX = gY.x;
                nY = gY.y;
                g = gY;
                // console.log("gy")
            }

            if ((panel.y > g.y && panel.x > g.x && panel.x < (g.x + g.width))) {
                //console.log('panel.y',panel.y , g.y,g.nModWith,g);
                // top
                //console.log("top");
                nY = g.y + g.height + nVSpace;
                let v = parseInt((panel.x - g.x) / (g.nModWith) + '') * (g.nModWith + nHSpace) + g.x;
                //console.log("v",v," panex.x",panel.x);
                nX = panel.x;
                if (Math.abs(v - panel.x) <= this.nSnapVal) {
                    console.log("top1");
                    nX = v;
                }
                v = (parseInt((panel.x - g.x) / (g.nModWith) + '') + 1) * (g.nModWith + nHSpace) + g.x;
                //console.log("v",v," panex.x",panel.x);
                if (Math.abs(v - panel.x) <= this.nSnapVal) {
                    //console.log("top2");
                    nX = v;
                }
                if ((panel.x + panel.width) >= (g.x + g.width) && (panel.x) >= (g.x + g.width)) {
                    //console.log("top3");
                    const v = g.y;
                    nY = Math.abs(v - panel.y) > this.nSnapVal ? panel.y : v;
                    nX = g.x + g.width + nHSpace;
                }
                const factor: any = parseInt("" + (panel.x - g.x) / (g.nModWith + 0.7))
                const nearest: any = (g.x + g.nModWith + 0.7) * factor;
                if (panel.x >= (nearest - 60) && panel.x <= (nearest + 60)) {
                    //console.log("top4");
                    // console.log("bottom---");
                    nX = g.x;
                }
                //console.log('condition nX , nY',nX,nY); 
                //if(panel.width)
            }


            if ((panel.y + panel.height) < (g.y) && panel.x > g.x && panel.x < (g.x + g.width)) {
                // bottom
                //console.log("bottom ");
                nY = g.y - g.height - nVSpace;
                let v = parseInt((panel.x - g.x) / (g.nModWith) + '') * (g.nModWith + nHSpace) + g.x;
                nX = Math.abs(v - panel.x) > this.nSnapVal ? panel.x : v;
                //snap fit to bottom 
                v = (parseInt((panel.x - g.x) / (g.nModWith) + '') + 1) * (g.nModWith + nHSpace) + g.x;
                if (Math.abs(v - panel.x) <= this.nSnapVal) {
                    //console.log("bottom2");
                    nX = v;
                }
                //console.log('condition nX , nY',nX,nY);
            }

            if (panel.x >= (g.x + g.width)) {
                // left
                 //console.log("left");
                let v = g.y;
                //console.log("left2",v,panel.y);
                nY = Math.abs(v - panel.y) >= this.nSnapVal ?  0 : v;
                nX = g.x + g.width + nHSpace;
                //console.log('condition nX , nY',nX,nY);
                
                
            }
            if ((panel.x) <= (g.x)) {
                // right
                 //console.log("right");
                const v = g.y;
                nY = Math.abs(v - panel.y) > this.nSnapVal ? 0 : v;
                // nY = g.y;
                nX = g.x - panel.width - nHSpace;
                if (panel.y > (g.y + g.height)) {
                    // bottom left
                    // console.log("right bottom");
                    nY = g.y + g.height + nVSpace;
                    const v = g.x;
                    nX = Math.abs(v - panel.x) > this.nSnapVal ? panel.x : v;
                }
                if ((panel.y + panel.height) < (g.y + 60) && (panel.x + panel.width) > g.x) {
                    // console.log("top");
                    nX = Math.abs(g.x - panel.x) <= 60 ? g.x : panel.x;
                    nY = g.y - panel.height - nVSpace;
                }
                // console.log(g);
                //replace 30 with 60 for better snapping results
                //console.log('condition nX , nY',nX,nY);
            }
        } else {
            nX = 0
            nY = 0;
        }
        if (nX == 0 || nY == 0)
            if (panel.y < (g.y + g.height) && panel.y > (g.y) && panel.x > g.x && panel.x < (g.x + g.width)) {
                
                // bottom
                //console.log("bottom overlapping");
                nY = g.y + g.height + nVSpace;
                const v = parseInt((panel.x - g.x) / (g.nModWith) + '') * (g.nModWith + nHSpace) + g.x;
                nX = Math.abs(v - panel.x) > this.nSnapVal ? panel.x : v;
                if (Math.abs(nY - panel.y) > 60) {
                    if (panel.x >= (g.x + g.width / 2)) {
                        // left
                        // console.log("left");
                        const v = g.y;
                        nY = Math.abs(v - panel.y) > this.nSnapVal ? panel.y : v;
                        nX = g.x + g.width + nHSpace;

                    }
                    if (panel.x <= (g.x)) {
                        // right
                        // console.log("right");
                        const v = g.y;
                        nY = Math.abs(v - panel.y) > this.nSnapVal ? panel.y : v;
                        nX = g.x - panel.width - nHSpace;
                    }
                }

            } else if ((panel.y) < (g.y) && (panel.y + panel.height) > g.y && (panel.y + panel.height) < (g.y + g.height) && panel.y > g.y && panel.x > g.x && panel.x < (g.x + g.width)) {
                //console.log("top overlapping");
                nY = g.y - g.height - nVSpace;
                nX = parseInt((panel.x - g.x) / (g.nModWith) + '') * (g.nModWith + nHSpace) + g.x;
            }
        // if ((panel.y) < (g.y) && panel.x > g.x && panel.x < (g.x + g.width)) {
        //     console.log("top overlap");
        //     nY = g.y - g.height - nVSpace;
        //     const v = parseInt((panel.x - g.x) / (g.nModWith) + '') * (g.nModWith + nHSpace) + g.x;
        //     nX = Math.abs(v - panel.x) > this.nSnapVal ? panel.x : v;
        // }
        //  if (nY >= (g.y)) {
        //     // left or Right

        // }
        // console.log(g)
        //console.log('final nX , nY',nX,nY ,g.mixed);
        if (Math.abs(panel.x - nX) > 60 || Math.abs(panel.y - nY) > 60 || g.mixed) {
            //console.log('outside');
            return {
                x: 0,
                y: 0,
                w: panel.width,
                h: panel.height,
                g: g
            }
        }
        return {
            x: nX > 100 ? nX : 0,
            y: nY > 100 ? nY : 0,
            w: panel.width,
            h: panel.height,
            g: g
        }
    }//
}
